import { Component, EventEmitter, inject, input, Input, OnDestroy, Output } from "@angular/core";
import { MatLegacyCheckboxChange as MatCheckboxChange } from "@angular/material/legacy-checkbox";
import { TppPayouts } from "../../models/tpp-payment.interface";
import { Transaction } from "src/app/shared/models/payouts.types";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { PayoutStatusHistoryDialogComponent } from "../../../_components/payouts/payout-list-item/payout-status-history-dialog/payout-status-history-dialog.component";
import { PermissionsService } from "@shared/services/permissions/permissions.service";
import { Subject, take, takeUntil } from "rxjs";
import { EmployeeService } from "@shared/services/employee/employee.service";
import { CommonService } from "@modules/dashboard/services/common.service";
import { MilestoneEventHistoryLogData } from "@modules/global-dashboard/models/global-dashboard-interface";
import { HistoryLogSidePanelService } from "@shared/components/history-log-side-panel/services/history-log-side-panel.service";

@Component({
	selector: "app-tpp-payment-payout-item-detail-list-item",
	templateUrl: "./tpp-payment-payout-item-detail-list-item.component.html",
	styleUrls: ["./tpp-payment-payout-item-detail-list-item.component.scss"]
})
export class TppPaymentPayoutItemDetailListItemComponent implements OnDestroy {
	@Input() set _payout(payout: TppPayouts) {
		this.payout = payout;
		this.payoutTransactions = payout.transactions;
		this.setupPermissions();
		this.employeeIdConversion();
	}

	@Input() set _isCancelledRun(cancelled: boolean) {
		this.isCancelledRun = cancelled;
	}
	@Input() set _isLast(last: boolean) {
		this.isLast = last;
	}

	@Input() set _reprocessPayoutIdsList(ids: string[]) {
		this.reprocessIds = ids;
	}

	isInActivatedPayout!: boolean;
	@Input() set _isInActivatedPayout(val: boolean) {
		this.isInActivatedPayout = val;
	}

	@Output() pushToReprocessList: EventEmitter<string[]> = new EventEmitter<string[]>();
	@Output() popFromReprocessList: EventEmitter<string[]> = new EventEmitter<string[]>();
	@Output() inActivatePayouts: EventEmitter<string[]> = new EventEmitter<string[]>();

	payout!: TppPayouts;
	payoutTransactions!: Transaction[];
	reprocessIds: string[] = [];
	isLast = false;
	isCancelledRun = false;
	canViewTransactionHistory = false;
	canReprocessPayment = false;

	private destroy$ = new Subject<void>();

	public dialog = inject(MatDialog);
	private permissions = inject(PermissionsService);
	private employeeService = inject(EmployeeService);
	private commonService = inject(CommonService);
	private historyLogService = inject(HistoryLogSidePanelService);

	bulkSelected$ = this.commonService.isBulkSelected$;

	employeeIdConversion(): void {
		if (this.payout.employeeId) {
			this.employeeService
				.getEmployeesById(this.payout.employeeId)
				.pipe(take(1))
				.subscribe(result => {
					this.payout.employeeId = result.externalId;
				});
		}
	}

	setupPermissions() {
		this.permissions
			.canViewTransactionHistoryTPP()
			.pipe(takeUntil(this.destroy$))
			.subscribe(viewRes => (this.canViewTransactionHistory = viewRes));

		this.permissions
			.canReprocessBookings()
			.pipe(takeUntil(this.destroy$))
			.subscribe(res => (this.canReprocessPayment = res));
	}

	setIds(event: MatCheckboxChange, payoutIds: string[]) {
		if (event.source.checked === true) {
			this.pushToReprocessList.emit(payoutIds);
		} else {
			this.popFromReprocessList.emit(payoutIds);
		}
	}

	showHistory() {
		this.historyLogService.setTransactionData(this.payout.id);
	}

	openDialog(): void {
		const dialogRefData = {
			payoutTransactions: this.payoutTransactions
		};

		const dialogRef = this.dialog.open(PayoutStatusHistoryDialogComponent, {
			width: "1100px",
			panelClass: "dialog-container",
			data: dialogRefData
		});

		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (result) {
				//this.location.back();
			}
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
